import React from 'react'
import { Tooltip } from '@mui/material'
import { SystemUpdateAltRounded } from '@mui/icons-material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { rowHasOperationUpdate } from './operationApprovedUpdate'

/**
 * WorkflowTableOperationUpdate (C8, §8.7) — el indicador de la fila de un workflow que tiene algún
 * nodo vinculado a una operación con versión más nueva (CA5.1, S86).
 *
 * La bandera llega EN LA FILA (`operationUpdateAvailable`, §8.5): resolverla por fila sería un N+1
 * sobre un listado paginado, y por eso Sun la calcula en lote. Ausente se lee como false.
 * Solo la puebla `POST getWorkflows`, y solo en la ÚLTIMA versión del workflow.
 */
const WorkflowTableOperationUpdate = ({ row = {} }) => {
  const { t_ } = useSmartTranslation()

  if (!rowHasOperationUpdate(row)) return null

  return (
    <Tooltip title={t_('Update available')}>
      <SystemUpdateAltRounded color='info' data-testid='workflow-operation-update-indicator' />
    </Tooltip>
  )
}

export default WorkflowTableOperationUpdate
